<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/registry']"
        >
          Registry
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/qaRun']"
        >
          QA Run
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/internalLinks']"
        >
          Internal Links
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageDashboard']"
        >
          On-P Insights
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing']"
        >
          Keywords
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          Off-P Recomm
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageProspects']"
        >
          Off-P Prospects
        </a>
        <a class="btn btn-dark btn-sm btn-reg"> Off-P Backlinks </a>
      </div>
    </div>
  </div>

  <div class="row mb-3 mt-1">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filter()"
          list="suggestionsBacklinks"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent">
          <i class="fas fa-search text-dark"></i>
        </span>
        <datalist id="suggestionsBacklinks">
          <option
            *ngFor="let suggestion of searchSuggestions"
            [value]="suggestion"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th class="city-cell">Source Domain</th>
              <th class="city-cell">Source URL</th>
              <th class="city-cell">Target URL</th>
              <th>Anchor</th>
              <th>RelType</th>
              <th>Placement</th>
              <th>Status</th>
              <th>FirstSeen</th>
              <th>LastSeen</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td
                class="title-cell"
                (click)="showModal('Source Domain', item.sourceDomain)"
                title="Click to view"
              >
                {{ item.sourceDomain }}
              </td>
              <td class="city-cell">
                <a
                  [href]="item.sourceUrl"
                  target="_blank"
                  class="text-info"
                  title="Source URL"
                >
                  <i class="fas fa-external-link-alt"></i>
                </a>
              </td>
              <td class="city-cell">
                <a
                  [href]="item.targetUrl"
                  target="_blank"
                  class="text-info"
                  title="Target URL"
                >
                  <i class="fas fa-link"></i>
                </a>
              </td>
              <td class="city-cell">{{ item.anchorText }}</td>
              <td class="city-cell">{{ item.relType }}</td>
              <td>{{ item.linkPlacement }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="getStatusBadgeClass(item.backlinkStatus || item.status)"
                >
                  {{ (item.backlinkStatus || item.status) | uppercase }}
                </span>
              </td>
              <td>{{ item.firstSeenAt | date: "shortDate" }}</td>
              <td>{{ item.lastSeenAt | date: "shortDate" }}</td>
              <td class="text-nowrap">
                <a
                  class="btn btn-link text-info btn-sm"
                  [routerLink]="[
                    '/marketing/seo/offPageBacklinks/view',
                    item._id,
                  ]"
                  title="View"
                >
                  <i class="fas fa-eye"></i>
                </a>

                <button
                  *ngIf="item.backlinkStatus !== 'live'"
                  (click)="markLive(item._id)"
                  class="btn btn-link text-success btn-sm"
                  title="Mark Live"
                >
                  <i class="fas fa-check-circle"></i>
                </button>

                <button
                  *ngIf="
                    item.backlinkStatus === 'live' ||
                    item.backlinkStatus === 'pending'
                  "
                  (click)="markLost(item._id)"
                  class="btn btn-link text-danger btn-sm"
                  title="Mark Lost"
                >
                  <i class="fas fa-times-circle"></i>
                </button>

                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-secondary btn-sm"
                  title="Delete"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
